module.exports = __webpack_public_path__ + "img/fruit-currants-350x184.bed07899.jpg";